export default __webpack_public_path__ + "static/media/hetimiul_2.cf2635d1.png";